export const API_TOKEN = 'API_TOKEN_1'
export const LEGACY_AUTHENTICATION_PASSWORD = 'LEGACY_AUTHENTICATION_PASSWORD'
export const DEPRECATED_LEGACY_AUTHENTICATION_PASSWORD = 'token'
